import Vue from 'vue'
import Router from 'vue-router'
const TestTip = resolve => require(['../components/TestTip.vue'], resolve); //拍照前提示
const TestImg = resolve => require(['../components/TestImgIos.vue'], resolve); //拍照前照片提示
const TestTransition = resolve => require(['../components/TestTransition.vue'], resolve); //拍照前照片提示
const TestQuestion = resolve => require(['../components/TestQuestion.vue'], resolve); //问诊
const NotFound = resolve => require(['../components/NotFound.vue'], resolve);
const ReportDetails = resolve => require(['../components/ReportDetails.vue'], resolve);
const sendReport = resolve => require(['../components/sendReport.vue'], resolve);
const report = resolve => require(['../components/report.vue'], resolve);
const myReport = resolve => require(['../components/myReport.vue'], resolve);
const savewx = resolve => require(['../components/savewx.vue'], resolve)

Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: '/',
    routes: [{
            path: '/',
            redirect: '/tip'
        },
        //评估开始 拍照前提示页
        {
            path: '/tip',
            name: 'TestTip',
            component: TestTip
        },
        // 照片页type 1-面诊 2-舌诊
        {
            path: '/img/:type',
            name: 'TestImg',
            component: TestImg
        },
        // 舌诊结束，开始进入问诊
        {
            path: '/test/transition',
            name: 'TestTransition',
            component: TestTransition
        },
        //问诊
        {
            path: '/question',
            name: 'TestQuestion',
            component: TestQuestion
        },
        // 404页面
        {
            path: '*',
            name: 'NotFound',
            component: NotFound
        },
        {
            path: '/test/reportDetails', //?code=
            //component: ReportDetails
            component: myReport
        },
        {
            path: '/test/reportPlan',
            component: sendReport
        },
        {
            path: '/report',
            component: report
        },
        {
            path: '/save/wx',
            component: savewx,
        }
    ]
})

router.afterEach(to => {
    if (gtag) {
        gtag('config', 'UA-139122490-3', { 'page_path': to.fullPath })
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js